var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import "../inputTextField/index.scss";
import "./index.scss";
import { useState } from "react";
import { SelectStyle } from "./style";
var STYLETYPE;
(function (STYLETYPE) {
    STYLETYPE["ROUNDED_INPUT"] = "rounded";
    STYLETYPE["BORDER_BOTTOM_INPUT"] = "line";
    STYLETYPE["DEFAULT"] = "default";
})(STYLETYPE || (STYLETYPE = {}));
function SelectField(props) {
    var _a = useState(false), focus = _a[0], changeFocus = _a[1];
    var handleBlur = function (event) {
        if (props.handleBlur) {
            props.handleBlur(event.currentTarget.value);
        }
        changeFocus(false);
    };
    return (React.createElement("div", { className: "select-field-container" },
        React.createElement("div", { className: "label-wrapper" },
            React.createElement("label", { style: STYLETYPE.ROUNDED_INPUT === props.styleType ? SelectStyle.roundedStyle.label : STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ? SelectStyle.lineStyle.label : STYLETYPE.DEFAULT === props.styleType ? SelectStyle.defaultStyle.label : {}, htmlFor: props.fieldName }, props.name)),
        props.tooltipLabel &&
            React.createElement("div", { className: "form-tooltip" },
                React.createElement("span", { className: "form-tooltiptext form-tooltip-right" }, props.tooltipLabel)),
        React.createElement("select", { id: props.fieldName, className: "s-form-select-control", value: props.value, style: STYLETYPE.ROUNDED_INPUT === props.styleType ? focus ? __assign(__assign({}, SelectStyle.roundedStyle.default), SelectStyle.roundedStyle.focus) : SelectStyle.roundedStyle.default :
                STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ? focus ? __assign(__assign({}, SelectStyle.lineStyle.default), SelectStyle.lineStyle.focus) : SelectStyle.lineStyle.default :
                    STYLETYPE.DEFAULT === props.styleType ? focus ? __assign(__assign({}, SelectStyle.defaultStyle.default), SelectStyle.defaultStyle.focus) : SelectStyle.defaultStyle.default : {}, onChange: function (e) { return props.onChangeHandler(props.fieldName, e.target.value); }, onBlur: handleBlur, onFocus: function () { return changeFocus(true); }, disabled: props.disabled ? props.disabled : false }, props.options.map(function (item, index) {
            return (React.createElement("option", { disabled: item.isDisabled, style: STYLETYPE.ROUNDED_INPUT === props.styleType ? SelectStyle.roundedStyle.optionStyle : STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ? SelectStyle.lineStyle.optionStyle : STYLETYPE.DEFAULT === props.styleType ? SelectStyle.defaultStyle.optionStyle : {}, value: item.value, key: index }, item.name));
        })),
        !props.isRequired && React.createElement("span", { className: "form-optional" }, "Optional"),
        props.errorMsg &&
            React.createElement("div", { className: "error-message flex-center-row" }, props.errorMsg)));
}
SelectField.defaultProps = {
    isRequired: true,
    styleType: "default",
};
export default SelectField;
//# sourceMappingURL=index.js.map